var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
'app',
_vm.user.listPermissions(),
_vm.isPrint ? 'print' : ''
],attrs:{"id":"app"}},[_c('the-header'),_c('the-main'),_c('the-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }